<template>
  <div class="pw_bg">
     <div class="pwContent">
         <div class="pwHeard">
           <span class="h_back" @click="back"></span>
           <span class="h_title">修改密码</span>
         </div>
       <div class="pwForm">
         <span>原密码</span><input type="password" class="oldPw" v-model="oldPassWord" v-on:blur="checkPassword(oldPassWord)">
         <span>新密码</span><input type="password" class="newPw" v-model="newPassWord" v-on:input="preCheckPassword(newPassWord)">
         <span>确认密码</span><input type="password" class="confirmPw" v-model="confirmPassWord" v-on:blur="preConfirmPassWord(confirmPassWord)">
         <p class="formTip" v-show="passOrCro">{{tips}}</p>
       </div>
       <a  href="javascript:void (0);" class="formBtn" @click="confirmWord">修改密码</a>
     </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  import { Indicator } from 'mint-ui';
  import {api} from '../global/api';
    export default {
        name: "pass-word",
      data(){
          return {
            passOrCro:false,
            oldPassWord:"",
            newPassWord:"",
            confirmPassWord:"",
            tips:"两次密码不统一，请重新输入",
            oldFlag:false,   //原密码校验成功
            regFlag:false,     //正则校验
            newFlag:false      //确认密码校验
          }
      },
      mounted(){

      },
      methods:{
        back(){
          this.$router.go(-1);
        },
        confirmWord(){
          let that=this;
          if(this.regFlag&&this.oldFlag&& this.newFlag){
            let params={"userID":localStorage['userid'],"token":localStorage['token'],"password":this.$getRsaCode(this.newPassWord)};
            // this.$http.get(api.modifyPassword, {params:params}).then(response => {
            this.$http.post(api.modifyPassword, params, {
              emulateJSON: true
            }).then(response => {
                  if(response.data.success==1){
                    let instance = Toast(
                      {
                        message: '修改成功！',
                        position: 'center',
                        duration: 2000,
                        iconClass: 'icon icon-success'
                      }
                    );
                    setTimeout(() => {
                      instance.close();
                      history.back()
                    }, 2000);
                  }
            }, response => {
              console.log("请求失败了");
            })
          }else{

          }
        },
        preConfirmPassWord(val){
         // debugger
             if(this.regFlag&&this.oldFlag){              //确认密码校验
               if(this.confirmPassWord==this.newPassWord){
                 this.newFlag=true;
                 this.passOrCro=false;
               }else{
                 this.tips="两次密码不统一，请重新输入";
                 this.passOrCro=true;
               }
             }else{
              //  this.tips="请输入6至10位,且至少包含一个数字、字母";
               this.tips="密码必须包含字母、数字，且至少8位";
               this.passOrCro=true;
             }
        },
        preCheckPassword(val){
          if(this.newPassWord=="")return false
          if(this.oldFlag){     //原密码校验成功才做新旧校验
           // debugger
            // if(!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/.test(this.newPassWord)){
            if(!/^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$/.test(this.newPassWord)){
              this.tips="密码必须包含字母、数字，且至少8位";
              this.passOrCro=true;
              return false
            }else{
              this.regFlag=true;
              this.passOrCro=false;
            }
          }else{
            return false
          }

        },
        checkPassword(val){
          let that=this;
          let params={"userID":localStorage['userid'],"token":localStorage['token'],"password":this.$getRsaCode(val)};
          this.$http.post(api.checkPassword, params, {
              emulateJSON: true
            }).then(response => {

              if(response.data.success==1){
                that.oldFlag=true;
              }else if(response.data.success==999){
                //that.oldFlag=false;
                this.$router.push({ path: './login'})
              }else{
                that.oldFlag=false;
                that.tips="原密码不正确";
                that.passOrCro=true;
              }
          }, response => {
            console.log("请求失败了");
          })
        }
      }
    }
</script>

<style scoped>
  .pw_bg{
    position: relative;
    /*width: 18.75rem;
    height: 27.1rem;*/
    width: 100%;
    height: 100vh;
    background-color: rgba(196, 77, 65, 0.85);
    background: url("../../static/images/pw_bg.png") center repeat-y;
    background-size: 100% 100%;
  }
  .pwHeard{
    position: relative;
    width:100%;
    height: 1rem;
  }
  .h_back{
    background: url("../../static/images/back_black.svg") center no-repeat;
    background-size: 100% 100%;
    width: .55rem;
    height: 1rem;
    float: left;
    display: block;
  }
.pwContent{
  width: 15.75rem;
  height: 23.8rem;
  border-radius: 0.4rem;
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  left:0;
  right: 0;
  top: -2.45rem;
  bottom: 0;
  margin: auto;
  padding: .7rem .75rem;
}
  .h_title{
    /* width: 3.2rem; */
    height: 1rem;
    line-height: 1rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.8rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    display: block;
    vertical-align: top;
    margin: 0 auto;
  }
  .pwForm{
    margin-top: 2rem;
    position: relative;
  }
  .pwForm input{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(241, 241, 242, 1);
    margin-bottom: .5rem;
    border: none;
    text-indent: 3.1rem;
  }
  .confirmPw{
    text-indent: 3.8rem!important;
  }
  .pwForm span{
    position: absolute;
    height: 1.8rem;
    line-height: 1.8rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFangSC-Medium;
    left: .5rem;
  }
  .formTip{
    height: 0.85rem;
    line-height: 0.85rem;
    color: rgba(196, 77, 65, 1);
    font-size: 0.6rem;
    text-align: left;
    font-family: PingFangSC-Regular;
  }
  .formBtn{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 0.4rem;
    background-color: rgba(196, 77, 65, 1);
    line-height: 1.8rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.7rem;
    text-align: center;
    font-family: PingFangSC-Medium;
    display: block;
    margin: 1.3rem auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/passWord.vue